import React from 'react';
import { PageLayout2 } from '../../Components/PageLayout/PageLayout2';
import LicenseManagement from '../../Components/LicenseManagement/LicenseManagement';

const LicenseManagementPage = () => (
    <PageLayout2 title="License Administration">
        <LicenseManagement />
    </PageLayout2>
);

export default LicenseManagementPage;
